"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const axios_1 = __importDefault(require("axios"));
const Pricing_1 = __importDefault(require("./Pricing"));
const FoodBeverage_1 = __importDefault(require("./FoodBeverage"));
function catering(props) {
    var _a, _b, _c, _d;
    const [cateringData, setCateringData] = (0, react_1.useState)(null);
    const [selectedBeveragePackage, setSelectedBeveragePackage] = (0, react_1.useState)(null);
    const [selectedFoodPackage, setSelectedFoodPackage] = (0, react_1.useState)(null);
    const [firstRender, setFirstRender] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        getCateringData();
    }, [props]);
    const beveragePackageCount = () => { var _a; return (_a = cateringData === null || cateringData === void 0 ? void 0 : cateringData.beveragePackages.size) !== null && _a !== void 0 ? _a : 0; };
    const foodPackageCount = () => { var _a; return (_a = cateringData === null || cateringData === void 0 ? void 0 : cateringData.foodPackages.size) !== null && _a !== void 0 ? _a : 0; };
    const getCateringData = () => {
        const params = new URLSearchParams();
        params.append("selectedDate", props.selectedDate.toString());
        const baseUrl = "/api/widget/foodBeveragePackages/" + props.uuid;
        axios_1.default
            .get(baseUrl, {
            params: params,
        })
            .then((response) => {
            const cateringData = {
                beveragePackages: new Map(response.data.beveragePackages.map((item) => [item.uid, item])),
                foodPackages: new Map(response.data.foodPackages.map((item) => [item.uid, item])),
            };
            setCateringData(cateringData);
            if (firstRender) {
                setTimeout(() => {
                    var _a;
                    (_a = document.getElementById(props.parentElementId)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
                    setFirstRender(false);
                }, 500);
            }
        })
            .catch((error) => {
            console.log(error);
        });
    };
    console.log("selectedFoodPackage", selectedFoodPackage);
    console.log("selectedBeveragePackage", selectedBeveragePackage);
    return (react_1.default.createElement("div", { id: "catering" },
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 4 },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(material_1.Grid, { container: true, width: "100%" },
                        !cateringData && react_1.default.createElement(material_1.Typography, null, "Loading catering packages."),
                        cateringData && (react_1.default.createElement(react_1.default.Fragment, null,
                            foodPackageCount() > 0 && (react_1.default.createElement(material_1.Grid, { container: true, spacing: 4 },
                                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                                        react_1.default.createElement(material_1.Typography, { variant: "h4" }, "Food Package")),
                                    react_1.default.createElement(FoodBeverage_1.default, { packages: Array.from(cateringData.foodPackages.values()), onSelectPackage: setSelectedFoodPackage })))),
                            (foodPackageCount() == 0 || (selectedFoodPackage &&
                                ((_b = (_a = cateringData.foodPackages) === null || _a === void 0 ? void 0 : _a.get(selectedFoodPackage)) === null || _b === void 0 ? void 0 : _b.type) === "food")) &&
                                beveragePackageCount() > 0 && (react_1.default.createElement(material_1.Grid, { container: true, spacing: 4, marginTop: 4 },
                                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                                        react_1.default.createElement(material_1.Typography, { variant: "h4" }, "Beverage Package")),
                                    react_1.default.createElement(FoodBeverage_1.default, { packages: Array.from(cateringData.beveragePackages.values()), onSelectPackage: setSelectedBeveragePackage }))))))))),
            (foodPackageCount() == 0 || selectedFoodPackage) &&
                ((beveragePackageCount() == 0 || selectedBeveragePackage) ||
                    (selectedFoodPackage && ((_d = (_c = cateringData === null || cateringData === void 0 ? void 0 : cateringData.foodPackages) === null || _c === void 0 ? void 0 : _c.get(selectedFoodPackage)) === null || _d === void 0 ? void 0 : _d.type) === "food_and_beverage")) && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(Pricing_1.default, { uuid: props.uuid, brandId: props.brandId, selectedDate: props.selectedDate, paxCount: props.paxCount, duration: props.duration, selectedTime: props.selectedTime, foodPackage: selectedFoodPackage, beveragePackage: selectedBeveragePackage }))))));
}
exports.default = catering;
